<mat-chip-grid #chipList>
  @for (tag of tags; track tag) {
    <mat-chip>
      {{tag}}
      <mat-icon matChipRemove (click)="remove(tag)">cancel</mat-icon>
    </mat-chip>
  }
  <input #tagInput placeholder="New tag..."
    [matChipInputFor]="chipList"
    [matAutocomplete]="auto"
    (matChipInputTokenEnd)="add($event)" (input)="change($event)"/>
  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
    @for (tag of filteredTags; track tag) {
      <mat-option [value]="tag">{{tag}}</mat-option>
    }
  </mat-autocomplete>
</mat-chip-grid>
